import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NpsService {

  constructor(private httpClient: HttpClient) { }

  showNps(userId: string, triggerEvent: string) {
    return this.httpClient.get(`api/show_nps`,
      { headers: { 'Content-Type': 'application/json' }, params: { userId: userId, triggerEvent: triggerEvent } })
  }
  updateNps(exposureId, score, comment) {
    debugger
    return this.httpClient.post('api/update_nps', JSON.stringify({ exposureId, score, comment }), {
      headers: { 'Content-Type': 'application/json' }
    })
  }
}
